import { render, staticRenderFns } from "./OrderInfoTable.vue?vue&type=template&id=72ab63ac&scoped=true&"
import script from "./OrderInfoTable.vue?vue&type=script&lang=js&"
export * from "./OrderInfoTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoTable.vue?vue&type=style&index=0&id=72ab63ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ab63ac",
  null
  
)

export default component.exports